var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboard4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.203,
    height: 44.203,
    viewBox: "0 0 44.203 44.203",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "money-send",
    transform: "translate(-428 -444)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(445.497 457.813)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0,9.688a3.151,3.151,0,0,0,3.076,3.223H6.538a2.742,2.742,0,0,0,2.671-2.818A2.433,2.433,0,0,0,7.386,7.422L1.842,5.489A2.42,2.42,0,0,1,.018,2.818,2.754,2.754,0,0,1,2.689,0H6.152A3.151,3.151,0,0,1,9.227,3.223",
    transform: "translate(0 1.823)",
    fill: "none",
    stroke: "#e74319",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M0,0V16.576",
    transform: "translate(4.604)",
    fill: "none",
    stroke: "#e74319",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M36.836,18.418A18.418,18.418,0,1,1,18.418,0",
    transform: "translate(431.684 447.684)",
    fill: "none",
    stroke: "#e74319",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M7.367,7.367V0H0",
    transform: "translate(461.152 447.684)",
    fill: "none",
    stroke: "#e74319",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M0,9.209,9.209,0",
    transform: "translate(459.31 447.684)",
    fill: "none",
    stroke: "#e74319",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-6",
    "data-name": "Vector",
    d: "M0,0H44.2V44.2H0Z",
    transform: "translate(428 444)",
    fill: "none",
    opacity: 0
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard4);
export default __webpack_public_path__ + "static/media/dashboard4.ed73ec30e30d0887c4b4d19e9752577c.svg";
export { ForwardRef as ReactComponent };